import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Capitalize the first letter of each whitespace-separated word in a name
 * and lowercase the rest, regardless of how the name was originally stored
 * (ALL CAPS, all lowercase, mIxEd, etc.). Safe for empty/undefined input.
 */
export function capitalizeName<T extends string | null | undefined>(name: T): T {
  if (!name) return name;
  return (name as string)
    .split(/(\s+)/)
    .map((part) =>
      /^\s+$/.test(part) || part.length === 0
        ? part
        : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
    )
    .join("") as T;
}

